import { motion } from 'framer-motion'
import { useOrderStore } from '../../store/orderStore'
import './SuccessScreen.css'

interface SuccessScreenProps {
    txHash: string
    amount?: number
    network?: string
    onReset: () => void
}

export default function SuccessScreen({ txHash, amount, network, onReset }: SuccessScreenProps) {
    const { selectedPackage, developerAccess } = useOrderStore()
    const displayAmount = typeof amount === 'number' ? amount : ((selectedPackage?.price ?? 0) + (developerAccess?.price ?? 0))
    const displayNetwork = network || 'Coinbase Commerce'
    const safeTxHash = (txHash || '').toString()

    return (
        <motion.div
            className="success-screen glass"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
        >
            <div className="success-icon-container">
                <motion.div
                    className="success-circle"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: "spring", stiffness: 200, damping: 15, delay: 0.2 }}
                >
                    <svg viewBox="0 0 24 24" fill="none" className="check-icon">
                        <motion.path
                            d="M5 13l4 4L19 7"
                            stroke="currentColor"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            initial={{ pathLength: 0 }}
                            animate={{ pathLength: 1 }}
                            transition={{ duration: 0.5, delay: 0.5 }}
                        />
                    </svg>
                </motion.div>
                <div className="success-glow"></div>
            </div>

            <h2 className="success-title">Payment Successful!</h2>
            <p className="success-subtitle">
                Your order is being processed.
            </p>

            <div className="order-details-card">
                <div className="detail-row">
                    <span>Items</span>
                    <div className="flex flex-col items-end">
                        {selectedPackage && <span className="text-white">{selectedPackage.name}</span>}
                        {developerAccess && <span className="text-white">{developerAccess.name}</span>}
                        {!selectedPackage && !developerAccess && <span className="text-white">Ghost-Flash-$USDT$</span>}
                    </div>
                </div>
                <div className="detail-row">
                    <span>Total Paid</span>
                    <span className="text-neon">${displayAmount.toLocaleString()}</span>
                </div>
                <div className="detail-row">
                    <span>Network</span>
                    <span>{displayNetwork}</span>
                </div>
                <div className="detail-row">
                    <span>Transaction Hash</span>
                    <span className="hash-text">
                        {safeTxHash.length > 20
                            ? `${safeTxHash.substring(0, 10)}...${safeTxHash.substring(safeTxHash.length - 8)}`
                            : safeTxHash || '—'}
                    </span>
                </div>
            </div>

            <div className="delivery-status">
                <div className="status-step completed">
                    <div className="step-dot">✓</div>
                    <span>Payment Confirmed</span>
                </div>
                <div className="step-line active"></div>
                <div className="status-step active">
                    <div className="step-dot pulse"></div>
                    <span>Processing Delivery</span>
                </div>
                <div className="step-line"></div>
                <div className="status-step">
                    <div className="step-dot"></div>
                    <span>Dispatched</span>
                </div>
            </div>

            <div className="success-actions">
                <button className="btn btn-secondary" onClick={() => window.open(`#`, '_blank')}>
                    Download Receipt
                </button>
                <button className="btn btn-primary" onClick={onReset}>
                    Place New Order
                </button>
            </div>
        </motion.div>
    )
}
